import { useMemo } from 'react';
import { useSignupDirectCtx } from '../context';
import { getCommunicationConcernOptionsFromKeys } from '../misc/communicationConcerns';
import { filtersAllowForEvaluation } from './evaluationCriteria';
import { filtersAllowSplitEvaluation } from './splitEvaluationCriteria';
import { leadCanPickSchedule } from './schedulingCriteria';

export const useSignupRoutingRules = () => {
  const { filters, isResumedLead, resumedLeadState } = useSignupDirectCtx();

  if (!filters) throw new Error('Expected filters to be set');

  const isEvalAllowed = useMemo(
    () =>
      filtersAllowForEvaluation({
        clinicalConcerns: getCommunicationConcernOptionsFromKeys(filters.clinicalConcernKeys, filters.therapyTarget),
        language: filters.language,
        paymentMethod: filters.paymentMethod,
        target: filters.therapyTarget,
        isResumedLead,
      }),
    [filters],
  );
  const isSplitEvaluationAllowed = useMemo(
    () =>
      filtersAllowSplitEvaluation({
        paymentMethod: filters.paymentMethod,
      }),
    [filters, isResumedLead],
  );

  const isScheduleAllowed = useMemo(
    () => leadCanPickSchedule({ resumedLeadState, isEvalAllowed: isEvalAllowed.allowed }),
    [filters, isResumedLead, isEvalAllowed],
  );

  return {
    isEvalAllowed,
    isSplitEvaluationAllowed,
    isScheduleAllowed,
  };
};
